import * as types from '../actions/types'
import Immutable from 'immutable'
import moment from 'moment';

import {
    isPrimitive,
    solicitudbiitem,
    solicitudservicioitemcenco,
    foro
} from '../utils/helpers'

const INITIAL_STATE = Immutable.fromJS({
    solicitante: null,
    fecha_requerido: moment().format('YYYY-MM-DD'),
    tipo_almacen: '',
    proyecto_evento: '',
    observaciones: '',
    bienes: [],
    cencos: [],
    adjuntos: [],
    btnSaveDisabled: false,
    foros:[],
    comentario: {
        guid: null, 
        texto: null
    }
})

export default function (state = INITIAL_STATE, action) {
    let data, index
	switch (action.type) {
        case types.REINICIAR_SOLICITUD_BIENES_INVESTIGACION:
            return INITIAL_STATE
        case types.MODIFICAR_INPUTS_SOLICITUD_BIENES_INVESTIGACION:
            if (isPrimitive(action.payload.value)) {
    			state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
            } else {
                if (action.payload.immutable === false) {
                    state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
                } else {
                    state = state.setIn(`${action.payload.path}`.split('.'), Immutable.fromJS(action.payload.value))
                }
            }
            return state

        case types.ADICIONAR_NUEVO_ITEM_SOLICITUD_BIENES_INVESTIGACION:
            const newItem = Immutable.fromJS(solicitudbiitem())
            state = state.update('bienes', list => list.push(newItem))
            return state
        case types.MODIFICAR_ITEM_SOLICITUD_BIENES_INVESTIGACION:
            state = state.mergeIn(['bienes', action.index], action.data)
            return state
        case types.ELIMINAR_ITEMS_SOLICITUD_BIENES_INVESTIGACION:
            state = state.update('bienes', list => list.filter(item => !item.get('selected')))
            return state
		case types.ADICIONAR_NUEVO_CENCO_SOLICITUD_BIENES_INVESTIGACION:
            let actual = state.get('cencos').reduce((a ,b) => { a += Number(b.get('porcentaje')); return a }, 0)
			state = state.update('cencos', list => list.push(Immutable.fromJS(solicitudservicioitemcenco(actual))))
			return state
        case types.ELIMINAR_CENCOS_SOLICITUD_BIENES_INVESTIGACION_ITEM:
			state = state.update('cencos', list => list.filter(x => !x.get('selected')))
            return state
            
        case types.ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_BIENES_INVESTIGACION:
            data = action.payload
            index = state.get('adjuntos').findIndex(x => x.get('guid') === data.get('guid'))
            data = data.set('nombre', `${data.get('nombre')}`)
            if (index === -1) {
                state = state.set('adjuntos', state.get('adjuntos').push(data))
            } else {
                data = data.set('updated', true)
                state = state.setIn(['adjuntos', String(index)], data)
            }
            return state


        case types.ELIMINAR_ARCHIVOS_SOLICITUD_BIENES_INVESTIGACION:
            state = state.update('adjuntos', list => list.filter(x => !x.get('selected')))
            return state

        case types.CONMUTAR_SELECCION_TODOS_ITEMS_SOLICITUD_BIENES_INVESTIGACION:
            state = state.update('bienes', list => list.map(x => x.set('selected', action.payload)))
            return state
        
        case types.CONMUTAR_SELECCION_TODOS_CENCOS_SOLICITUD_BIENES_INVESTIGACION:
            state = state.update('cencos', list => list.map(x => x.set('selected', action.payload)))
            return state

        case types.ENVIAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION:
            index = state.get('foros').findIndex(c => c.get('guid') === action.payload.guid)
            if(index === -1){          
                const data = Immutable.fromJS(foro(action.payload.usuario, action.payload.comentario))
                state = state.set('foros', state.get('foros').push(data))
            }else{
                state = state.setIn(['foros', index, 'comentario'], action.payload.comentario)
            }
            state = state.set('comentario', INITIAL_STATE.get('comentario'));
            return state

        case types.EDITAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION:
            index = state.get('foros').findIndex(c => c.get('guid') === action.payload.guid)
            state = state.setIn(['comentario','guid'], action.payload.guid)
            state = state.setIn(['comentario','texto'], state.getIn(['foros', index, 'comentario']))
            return state

        case types.ELIMINAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION:
            index = state.get('foros').findIndex(c => c.get('guid') === action.payload.guid)
            state = state.deleteIn(['foros', index])
            return state
            
    	default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/reducers/creacionsolicitudbi.js